import { useCallback, useEffect, useState } from "react";

const STORAGE_KEY = "desire_favorites";

function readFavorites(): string[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed.map((v) => String(v)) : [];
  } catch {
    return [];
  }
}

export function useFavorites() {
  const [favorites, setFavorites] = useState<string[]>([]);

  useEffect(() => {
    setFavorites(readFavorites());
  }, []);

  const persist = useCallback((next: string[]) => {
    setFavorites(next);
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    } catch {
      /* ignore storage errors */
    }
  }, []);

  const isFavorite = useCallback(
    (id: string | number) => favorites.includes(String(id)),
    [favorites]
  );

  const toggleFavorite = useCallback(
    (id: string | number) => {
      const strId = String(id);
      const next = favorites.includes(strId)
        ? favorites.filter((f) => f !== strId)
        : [...favorites, strId];
      persist(next);
      return next.includes(strId);
    },
    [favorites, persist]
  );

  return { favorites, isFavorite, toggleFavorite };
}